document.addEventListener('DOMContentLoaded', () => {
  // If the verification code input has six digits, then it's a valid code, auto-submit the form.
  const codeInput = document.querySelector('input[name="code"]');
  if (codeInput && codeInput instanceof HTMLInputElement) {
    codeInput.addEventListener('input', () => {
      const code = codeInput.value;
      if (code.length === 6) {
        codeInput.form?.submit();
      }
    });
  }
});
